
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-infrastructure",
      function () {
        return require("private-next-pages/our-infrastructure/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-infrastructure"])
      });
    }
  